import * as React from 'react';
import { OutsideClick } from '@cian/outside-click-component';
import { QuestionMark } from './QuestionMark';
import { Popup } from '@cian/popup-component';
import * as styles from './AuctionApplyNewBetHint.css';

export interface IAuctionApplyNewBetHintProps {
  /** Новая ставка (возвращается в случае понижения ставки) */
  nextBet: number;
  /** Дата применения новой ставки (возвращается в случае понижения ставки) */
  applyNewBetDate: string | null | undefined;
}

export interface IAuctionApplyNewBetHintState {
  isShow: boolean;
}

export class AuctionApplyNewBetHint
extends React.Component<IAuctionApplyNewBetHintProps, IAuctionApplyNewBetHintState> {
  public state = {
    isShow: false,
  };

  public render() {
    const { nextBet, applyNewBetDate } = this.props;
    const { isShow } = this.state;

    return (
      <div className={styles['hint_wrapper']}>
        <div onClick={this.setPopupState(true)}>
          <QuestionMark />
        </div>

        {isShow &&
          <OutsideClick onOutsideClick={this.setPopupState(false)}>
            <Popup containerStyle={styles['popup_container']}>
              {applyNewBetDate
                ? <>
                    Новая ставка {nextBet} ₽ в сутки.<br />
                    Применится в {applyNewBetDate}
                  </>
                : <>
                    Обновите результаты поиска, чтобы увидеть<br />
                    своё объявление на новой странице
                  </>
              }
            </Popup>
          </OutsideClick>
        }
      </div>
    );
  }

  private setPopupState = (isShow: boolean) => () => {
    this.setState({ isShow });
  }
}
